import { render } from "./TeamContentScopePicker.vue?vue&type=template&id=ddc6cdd0"
import script from "./TeamContentScopePicker.vue?vue&type=script&setup=true&lang=js"
export * from "./TeamContentScopePicker.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Team/TeamContentScopePicker.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ddc6cdd0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ddc6cdd0', __exports__)) {
    api.reload('ddc6cdd0', __exports__)
  }
  
  module.hot.accept("./TeamContentScopePicker.vue?vue&type=template&id=ddc6cdd0", () => {
    api.rerender('ddc6cdd0', render)
  })

}


export default __exports__